/**
 * @generated SignedSource<<9b0bfbcfa246d53daea6513a2c0ca5fb>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersIsArchiveWallArticle$data = {
  readonly createdDate: number | null | undefined;
  readonly paywallTypes: ReadonlyArray<{
    readonly entityId: string;
  } | null | undefined> | null | undefined;
  readonly publishedDate: number | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsVelocityWallArticle">;
  readonly " $fragmentType": "helpersIsArchiveWallArticle";
};
export type helpersIsArchiveWallArticle$key = {
  readonly " $data"?: helpersIsArchiveWallArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersIsArchiveWallArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersIsArchiveWallArticle"
};

(node as any).hash = "20759885009aa42a350d07349eaae9da";

export default node;
